/* Welcome Screen Component */
import React from 'react';
import { LOCATION_ICONS } from '../utils/constants';
import { useNavigate } from 'react-router';

// Extend Window interface to include MAGNI_CURRENT_LOCATION property
declare global {
  interface Window {
    MAGNI_CURRENT_LOCATION?: string;
  }
}

/**
 * WelcomeScreen - The initial screen shown when a user accesses the sign-in/out kiosk
 * @param {Object} props - Component props
 * @param {Function} props.navigate - Function to navigate to different screens
 * @param {string} props.currentLocation - Current office location
 * @returns {JSX.Element} - Rendered component
 */
const WelcomeScreen = () => {
  const navigate = useNavigate();
  const currentLocation = window.MAGNI_CURRENT_LOCATION || 'Unknown Location';
  return (
    <div className="welcome-container">
      <h1 className="welcome-title">Welcome to {(currentLocation === 'Madison Heights' || currentLocation === 'Ferndale') ? 'Spraytek' : (currentLocation === 'Troy' || currentLocation === 'Shelby' || currentLocation === 'Portland') ? 'Depor'  : 'Magni'}</h1>
      <p className="welcome-subtitle">
        Please select your role to sign in or out
        <br />
        <span className="location-display">
          {LOCATION_ICONS[currentLocation]} Current location: {currentLocation}
        </span>
      </p>
      
      <div className="welcome-options">
        <div 
          className="welcome-button no-tap-highlight" 
          onClick={() => navigate('employee-options')}
        >
          <div className="welcome-button-icon">👨‍💼</div>
          <div className="welcome-button-label">Employee</div>
        </div>
        
        <div 
          className="welcome-button no-tap-highlight" 
          onClick={() => navigate('visitor-options')}
        >
          <div className="welcome-button-icon">👋</div>
          <div className="welcome-button-label">Visitor</div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;